module.exports = __webpack_public_path__ + "static/img/sleepy_blue.eed99beb.png";